var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { ref: "chatContainer", staticClass: "chat-container" }, [
      _vm.loading
        ? _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "20px" } },
            [_c("a-spin", { attrs: { tip: "加载中..." } })],
            1
          )
        : _vm.qaPairs.length === 0
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                color: "#999",
                padding: "20px"
              }
            },
            [_vm._v("\n        暂无对话内容\n      ")]
          )
        : _c(
            "div",
            _vm._l(_vm.qaPairs, function(qaPair, index) {
              return _c(
                "div",
                {
                  key: qaPair.id || index,
                  staticClass: "chat-message-wrapper"
                },
                [
                  _c(
                    "div",
                    { staticClass: "message-container user-container" },
                    [
                      _c("div", { staticClass: "message user-message" }, [
                        _c("div", { staticClass: "message-header" }, [
                          _c("span", { staticClass: "sender-name" }, [
                            _vm._v("用户")
                          ]),
                          _c("span", { staticClass: "message-time" }, [
                            _vm._v(_vm._s(_vm.formatDate(qaPair.created_at)))
                          ])
                        ]),
                        _c("div", { staticClass: "message-content" }, [
                          _vm._v(_vm._s(qaPair.query))
                        ])
                      ]),
                      _c("div", { staticClass: "avatar user-avatar" }, [
                        _vm._v("👤")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "message-container assistant-container" },
                    [
                      _c("div", { staticClass: "avatar assistant-avatar" }, [
                        _vm._v("🤖")
                      ]),
                      _c("div", { staticClass: "message assistant-message" }, [
                        _c("div", { staticClass: "message-header" }, [
                          _c("span", { staticClass: "sender-name" }, [
                            _vm._v("AI助手")
                          ]),
                          _c("span", { staticClass: "message-time" }, [
                            _vm._v(_vm._s(_vm.formatDate(qaPair.created_at)))
                          ])
                        ]),
                        _c("div", {
                          staticClass: "message-content",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.processedAnswer(qaPair.answer)
                            )
                          }
                        })
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
    ]),
    _vm.hasMore && !_vm.loading
      ? _c(
          "div",
          { staticStyle: { "text-align": "center", "margin-top": "20px" } },
          [
            _c(
              "a-button",
              { attrs: { loading: _vm.loading }, on: { click: _vm.loadMore } },
              [_vm._v("加载更多")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }